export default "__VITE_ASSET__BUpzsk$q__"